import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expired-page',
  templateUrl: './expired-page.component.html',
  styleUrls: ['./expired-page.component.css']
})
export class ExpiredPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
